import { render, staticRenderFns } from "./RootList.vue?vue&type=template&id=7aa785b4&scoped=true&"
import script from "./RootList.vue?vue&type=script&lang=js&"
export * from "./RootList.vue?vue&type=script&lang=js&"
import style0 from "./RootList.vue?vue&type=style&index=0&id=7aa785b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa785b4",
  null
  
)

export default component.exports